import { render, staticRenderFns } from "./DetailNotificationPopup.vue?vue&type=template&id=c510884a"
import script from "./DetailNotificationPopup.vue?vue&type=script&lang=js"
export * from "./DetailNotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports